import React, { useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Button } from '@app/components';
import { Form, Modal } from 'react-bootstrap';
import { updatePathwayNameAndStatus } from '@app/services/learningPathway';

const UpdatePathwayNameModal = (props) => {

    const [isLoading, setLoading] = useState(false);

    const updatePathwayNameAndStatusAPI = async (payload) => {
        try {
            setLoading(true);
            const resp = await updatePathwayNameAndStatus(props?.payload?.id, payload);
            if(resp.success === true){
                setLoading(false);
                toast.success(resp?.message);
                props.handleClose();
                props.callGetAllLearningPathwayData();
            }else{
                toast.error(resp?.errors[0]?.msg);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal server error');
        }
    };

    const { handleChange, values, handleSubmit, touched, errors } = useFormik({
        initialValues: {
            name: props?.payload?.name ? props?.payload?.name.replace(/^FCL-DEF\s*/, "") : '',
        },
        validationSchema: Yup.object({
            name: Yup.string().trim().required('Please enter pathway name'),
        }),
        onSubmit: (values) => {
            updatePathwayNameAndStatusAPI(values);
        },
        enableReinitialize: true,
    });

    return (
    <div>
        <Modal show={props.show} onHide={props.handleClose} size='sm'>
            <Modal.Header closeButton>
                <Modal.Title>Update Pathway Name</Modal.Title>
            </Modal.Header>
            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className='row'>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Pathway Name <span className="required">*</span></label>
                                <Form.Control 
                                    type="text" 
                                    name="name" 
                                    id="name" 
                                    placeholder="Enter pathway name" 
                                    value={values.name}
                                    onChange={handleChange}
                                />
                                {(touched.name && errors.name) && (
                                    <div className="text-danger">
                                        {errors.name}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" isLoading={isLoading} className="btn btn-primary mr-2">Update </Button>
                    <Button className='btn btn-default' onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </form>
        </Modal>
    </div>
  )
}

export default UpdatePathwayNameModal;